import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class ImageService {

  private pendingImages: any[] = [];
  private loadingImages: any[] = [];
  private queueTimeout: any = null;
  private maxConcurrentLoads: number = 4;
  
  constructor(
  ) {
    this.processQueue();
  }

  queue(image:any){
    //añadimos attributo para marcar que ya esta en cola de carga
    image.setAttribute('d-img-lazy-status', 'queued');

    //añadimos a la cola de carga
    this.pendingImages.push(image);
    console.log('image queued', image, this.pendingImages);
  }

  processQueue(){
    while(this.pendingImages.length > 0 && this.loadingImages.length < this.maxConcurrentLoads){
      this.loadNext();
    }
    //procesamos la cola de carga de nuevo cada segundo
    this.queueTimeout = setTimeout(() => { this.processQueue(); }, 1 * 1000);
  }

  loadNext(){
    if(this.pendingImages.length > 0){
      //sacamos la siguiente imagen de la cola
      let image = this.pendingImages.shift();
      
      //la añadimos a la lista de cargas en curso
      this.loadingImages.push(image);

      //establecemos el src para iniciar la carga
      image.src = image.getAttribute('d-img-lazy-src');

      //escuchamos eventos de carga para marcar la imagen como cargada y lanzar la carga de la siguiente
      image.onload = () => {
        console.log('image loaded', image);
        image.setAttribute('d-img-lazy-status', 'loaded');
        //la quitamos de la lista de cargas en curso
        this.loadingImages = this.loadingImages.filter((img) => img !== image);
      };

      //si da error, continuamos con la siguiente
      image.onerror = () => {
        console.log('image error', image);
        image.setAttribute('d-img-lazy-status', 'error');
        this.loadingImages = this.loadingImages.filter((img) => img !== image);
      };
    }else{
      //no quedan imágenes por cargar, limpiamos el timeout
      console.log('no more images to load');
    }
  }

}
